import React from 'react'
import { Link } from 'react-router-dom';

import styled from 'styled-components'

import searchIcon from '../../assets/searchIcon.svg';
import burgerIcon from '../../assets/burgerIcon.svg';
import SearchResults from './SearchResults';

export default function NavbarMobile({
  navbarRef,
  searchVisible,
  setSearchVisible,
  searchValue,
  setSearchValue,
  inputSearchRef,
  handleSearchBlur,
  handleSearchInputChange,
  handleClickSearchIcon,
  handleBurgerClick,
  menuRef,
  menuVisible,
  searchResults,
  visiblePages
}) {
  return (
    <>
    <Wrapper ref={navbarRef}>
      <HEADER $searchVisible={searchVisible}>
        <Link className='link' to='/'>ХИМЕРЫ</Link>
      </HEADER>
      <SEARCH
        $searchVisible={searchVisible}
      >
        <SEARCH_INPUT
          ref={inputSearchRef}
          $searchVisible={searchVisible}
          type="text"
          value={searchValue}
          placeholder="Поиск"
          onBlur={handleSearchBlur}
          onChange={handleSearchInputChange}
        />
      </SEARCH>

      <MENU_OPTIONS
        ref={menuRef}
        $menuVisible={menuVisible}
      >
        {visiblePages.map((page, index) => (
          <li key={index}>
            <Link className='link' to={`/${page.title}`}>{page.display_title}</Link>
          </li>
        ))}
      </MENU_OPTIONS>
      <div className="icons">
        <img src={searchIcon} alt="Search Icon" onClick={handleClickSearchIcon} />
        <img className="menu-icon" src={burgerIcon} alt="Menu Icon" onClick={handleBurgerClick} />
      </div>
    </Wrapper>

    <SearchResults
      navbarRef={navbarRef}
      searchResults={searchResults}
      searchVisible={searchVisible}
      setSearchVisible={setSearchVisible}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
    />
    </>
  )
}

const Wrapper = styled.div`
  min-height: 3.75rem;
  padding: 19px 22px 15px 24px;
  border-bottom: 1px solid #000;
  
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  & .icons {
    display: flex;
    gap: 1.5rem;
    order: 3;
  }
`;

const SEARCH = styled.div`
  display: ${props => props.$searchVisible ? 'flex' : 'none'};
  order: 1;
  align-items: center;
  justify-content: flex-start;
  width: 75%;
  height: 1.5rem;
`;

const SEARCH_INPUT = styled.input`
  border: none;
  outline: none;
  width: 100%;
  height: auto;

  font-family: var(--secondary-font);
  font-size: 1.25rem;
`;

const HEADER = styled.h1`
  display: ${props => props.$searchVisible ? 'none' : 'unset'};
  order: 1;

  font-size: 1.221rem;
  font-weight: 700;
  font-family: var(--primary-font);

  & .link {
    text-decoration: none;
    color: black;
  }
`;

const MENU_OPTIONS = styled.ul`
  margin: 0;
  padding-left: 1.5rem;

  display: ${props => props.$menuVisible ? 'flex' : 'hidden'};
  flex-direction: column;
  justify-content: end;
  gap: 1rem;
  order: 4;
  flex: 0 0 100%;

  list-style: none;

  overflow: hidden;
  opacity: ${props => props.$menuVisible ? '1' : '0'};
  height: ${props => props.$menuVisible ? '9.5rem' : '0'};
  
  transform: ${props => props.$menuVisible ? 'translateY(0)' : 'translateY(5px)'};
  transition: height 0.2s, transform 0.3s;

  & li .link {
    font-size: 1rem;
    font-weight: 700;
    font-family: var(--primary-font);
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  & li .link:hover {
    text-decoration: underline;
  }
`;